import { render, staticRenderFns } from "./MCase.vue?vue&type=template&id=87d1778a&scoped=true&"
import script from "./MCase.vue?vue&type=script&lang=js&"
export * from "./MCase.vue?vue&type=script&lang=js&"
import style0 from "./MCase.vue?vue&type=style&index=0&id=87d1778a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87d1778a",
  null
  
)

export default component.exports